module.exports = "/images/pet-progress.svg?4c2f18899f3e3c57762709a2a702aa98";